import type { VoicePairSide } from '@/components/humint/voice/match/voice-pair-types'
import type { RecordingVoiceMatch } from '@/services/api/recording-voice-matches'

type MatchClip = Pick<VoicePairSide, 'waveform' | 'audioUrl' | 'audioMs'>

/** Only the selected speaker and the stored reference sample are offered to the transport. */
export function recordingMatchClips(match: RecordingVoiceMatch): {
  sides: readonly [MatchClip, MatchClip]
} {
  const side = (
    audio: RecordingVoiceMatch['reference'] | RecordingVoiceMatch['recording']
  ): MatchClip => ({
    audioUrl: audio.audio_url,
    audioMs: audio.audio_ms,
    waveform: null,
  })
  return { sides: [side(match.recording), side(match.reference)] }
}
